import React from 'react';

import { TOOL_PERMISSION, VIEWS } from 'pages/ToolManagement/toolManagementConfig';

const ToolManagementPage = React.lazy(() => import('pages/ToolManagement/ToolManagementPage'));
const ToolReceiptPage = React.lazy(() => import('pages/ToolManagement/ToolReceiptPage'));
const ToolRequestPage = React.lazy(() => import('pages/ToolManagement/ToolRequestPage'));
const ToolGroupPage = React.lazy(() => import('pages/ToolManagement/ToolGroupPage'));

const toolManagementRoute = Object.keys(VIEWS).map((view) => ({
  path: view === 'dashboard' ? '/tool-management' : `/tool-management/${view}`,
  exact: true,
  name: VIEWS[view].title,
  function: view === 'settings'
    ? TOOL_PERMISSION.ACCOUNTING_CONFIG
    : view === 'repairs'
      ? TOOL_PERMISSION.REPAIR_VIEW
    : view === 'reports'
      ? TOOL_PERMISSION.REPORT_VIEW
      : TOOL_PERMISSION.VIEW,
  component: () => view === 'receipts' ? <ToolReceiptPage /> : <ToolManagementPage view={view} />,
}));

export default [...toolManagementRoute, { path: '/tool-management/requests', exact: true, name: 'Yêu cầu cấp CCDC', function: TOOL_PERMISSION.VIEW, component: ToolRequestPage }, { path: '/tool-management/groups', exact: true, name: 'Nhóm công cụ dụng cụ', function: TOOL_PERMISSION.VIEW, component: ToolGroupPage }];
